<template>
  <div>
    form {{ formModel }}
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
